export const LocalStorageDefaults = {
  'LogoutRedirectRoute': 'LogoutRedirectRoute'
}